import React, { /* useEffect */ useState } from 'react'
import {
  Box,
  Badge,
  Button,
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  Heading,
  ModalCloseButton,
  ModalOverlay,
  SimpleGrid,
  useToast
} from '@chakra-ui/react'
import {
  INDUSTRIES_EN /* SHORT_INDUSTRIES_EN */,
  INDUSTRIES_ES
} from '../../filters'
import { filtersDataLayer } from '../../utils/gtmDatalayer'

const ModalFilters = ({
  isOpen,
  handleModal,
  accentColor,
  dictionary,
  lang,
  handleFilters,
  fontFamily,
  env,
  skin
}) => {
  const priceBadges = [
    { id: 1, value: dictionary.TABS.modal_price_1, label: '$' },
    { id: 2, value: dictionary.TABS.modal_price_2, label: '$$' },
    { id: 3, value: dictionary.TABS.modal_price_3, label: '$$$' },
    { id: 4, value: dictionary.TABS.modal_price_4, label: '$$$$' }
  ]

  const rewardTypeBadge = [
    {
      id: 1,
      slug: 'first_time',
      label:
        skin === 'INVEX'
          ? dictionary.TABS.modal_bonification_type_first_time
          : dictionary.TABS.modal_reward_type_first_time
    },
    {
      id: 0,
      slug: 'recurring',
      label:
        skin === 'INVEX'
          ? dictionary.TABS.modal_bonification_type_recurring
          : dictionary.TABS.modal_reward_type_recurring
    }
  ]

  const businessType = [
    {
      id: 0,
      slug: 'physicalVenue',
      label: dictionary.TABS.modal_business_type_physical
    },
    {
      id: 1,
      slug: 'ecommerce',
      label: dictionary.TABS.modal_business_type_ecommerce
    }
  ]

  const toast = useToast()

  const [currentCategory, setCurrentCategory] = useState([])
  const [currentPrice, setCurrentPrice] = useState([])
  const [currentReward, setCurrentReward] = useState([])
  const [currentBusinessType, setCurrentBusinessType] = useState([])

  // const [isExpanded, setExpanded] = useState(false)
  const [activeCategories] = useState(
    lang === 'ES' ? INDUSTRIES_ES : INDUSTRIES_EN
  )

  /* useEffect(() => {
    setCurrentCategory()
    setActiveCategories(
      isExpanded === true ? INDUSTRIES_EN : SHORT_INDUSTRIES_EN
    )
  }, [isExpanded]) */

  const handleCurrentCategories = (item, i) => {
    if (currentCategory.includes(item.slug)) {
      setCurrentCategory(currentCategory.filter((cat) => cat !== item.slug))
    } else {
      if (currentCategory.length <= 2) {
        setCurrentCategory((prevState) => [...prevState, item.slug])
      } else {
        toast({
          title: dictionary.TABS.modal_toast,
          status: 'error',
          isClosable: true
        })
      }
    }
  }

  const handleCurrentPrice = (item, i) => {
    if (currentPrice.includes(item.id)) {
      setCurrentPrice(currentPrice.filter((cat) => cat !== item.id))
    } else {
      if (currentPrice.length <= 0) {
        setCurrentPrice((prevState) => [...prevState, item.id])
      } else {
        setCurrentPrice([])
        setCurrentPrice((prevState) => [...prevState, item.id])
      }
    }
  }

  const handleCurrentRewardType = (item, i) => {
    if (currentReward.includes(item.slug)) {
      setCurrentReward(currentReward.filter((cat) => cat !== item.slug))
    } else {
      if (currentReward.length <= 0) {
        setCurrentReward((prevState) => [...prevState, item.slug])
      } else {
        setCurrentReward([])
        setCurrentReward((prevState) => [...prevState, item.slug])
      }
    }
  }

  const handleCurrentBusinessType = (item, i) => {
    if (currentBusinessType.includes(item.slug)) {
      setCurrentBusinessType(
        currentBusinessType.filter((cat) => cat !== item.slug)
      )
    } else {
      if (currentBusinessType.length <= 0) {
        setCurrentBusinessType((prevState) => [...prevState, item.slug])
      } else {
        setCurrentBusinessType([])
        setCurrentBusinessType((prevState) => [...prevState, item.slug])
      }
    }
  }

  const renderCategories = () => {
    return (
      <Box w='100%'>
        <Heading
          color='brand.secondaryDark'
          fontSize={['xl', 'xl', 'xl', 'xl']}
          fontFamily={fontFamily}
          fontWeight='700'
        >
          {dictionary.TABS.modal_category}
        </Heading>
        <Box w='100%' display='flex' flexFlow='wrap' pt='1rem'>
          {activeCategories.map((item, i) => {
            return (
              <Box
                key={i}
                p='0.5rem'
                cursor='pointer'
                onClick={() => handleCurrentCategories(item, i)}
              >
                <Badge
                  fontSize='0.8rem'
                  bg={
                    currentCategory.includes(item.slug) ? accentColor : 'white'
                  }
                  variant='solid'
                  color={
                    currentCategory.includes(item.slug) ? 'white' : accentColor
                  }
                  border={
                    skin === 'COPPEL'
                      ? `1px solid ${accentColor}`
                      : `2px solid ${accentColor}`
                  }
                  borderRadius={skin === 'COPPEL' ? '167px' : (skin === 'FINSUS' ? '4px' : '12px')}
                  shadow={skin !== 'COPPEL' && '2xl'}
                  p='0.3rem 0.5rem'
                  fontFamily={fontFamily}
                  fontWeight={skin === 'COPPEL' ? '450' : '700'}
                >
                  {item.label}
                </Badge>
              </Box>
            )
          })}
        </Box>
        {/* <Box w='100%' textAlign='center'>
          <Heading
            color={accentColor}
            textDecoration='underline'
            cursor='pointer'
            pt='0.4rem'
            fontSize={['sm', 'sm', 'sm', 'sm']}
            onClick={() => {
              isExpanded === true ? setExpanded(false) : setExpanded(true)
            }}
            fontWeight='500'
          >
            {isExpanded === true ? 'ver menos' : 'ver más'}
          </Heading>
        </Box> */}
      </Box>
    )
  }

  const renderPriceFilter = () => {
    return (
      <Box w='100%'>
        <Heading
          color='brand.secondaryDark'
          pt='2rem'
          fontSize={['xl', 'xl', 'xl', 'xl']}
        >
          {dictionary.TABS.modal_price}
        </Heading>
        <Box w='100%' pt='1rem'>
          <SimpleGrid columns={[2, 2, 4, 4]} spacingX='20px' spacingY='20px'>
            {priceBadges.map((item, i) => {
              return (
                <Box
                  key={i}
                  w='100%'
                  display='flex'
                  alignItems='center'
                  justifyContent='flex-start'
                  flexDirection='column'
                  cursor='pointer'
                  onClick={() => handleCurrentPrice(item, i)}
                >
                  <Badge
                    fontSize='1rem'
                    bg={currentPrice?.includes(item.id) ? accentColor : 'white'}
                    variant='solid'
                    color={
                      currentPrice?.includes(item.id) ? 'white' : accentColor
                    }
                    border={
                      skin === 'COPPEL'
                        ? `1px solid ${accentColor}`
                        : `2px solid ${accentColor}`
                    }
                    borderRadius={skin === 'COPPEL' ? '167px' : (skin === 'FINSUS' ? '4px' : '12px')}
                    p='0rem 0.5rem'
                    fontWeight={skin === 'COPPEL' ? '450' : '500'}
                  >
                    {item.label}
                  </Badge>
                  {/* <Heading
                    m='0px'
                    pt='0.4rem'
                    color='brand.secondaryDark'
                    textAlign='center'
                    fontSize={['sm', 'sm', 'xs', 'xs']}
                    fontWeight='500'
                  >
                    {item.value}
                  </Heading> */}
                </Box>
              )
            })}
          </SimpleGrid>
        </Box>
      </Box>
    )
  }

  const renderRewardType = () => {
    return (
      <Box w='100%'>
        <Heading
          color='brand.secondaryDark'
          pt='2rem'
          fontSize={['xl', 'xl', 'xl', 'xl']}
        >
          {skin === 'INVEX'
            ? dictionary.TABS.modal_bonification_type
            : dictionary.TABS.modal_reward_type}
        </Heading>
        <Box w='100%' pt='1rem'>
          <SimpleGrid columns={[1, 1, 1, 1]} spacingX='20px' spacingY='10px'>
            {rewardTypeBadge.map((item, i) => {
              return (
                <Box
                  key={i}
                  w='100%'
                  display='flex'
                  alignItems='flex-start'
                  justifyContent='center'
                  flexDirection='column'
                  p='0.5rem'
                >
                  <Badge
                    fontSize='0.8rem'
                    bg={
                      currentReward?.includes(item.slug) ? accentColor : 'white'
                    }
                    variant='solid'
                    color={
                      currentReward?.includes(item.slug) ? 'white' : accentColor
                    }
                    border={
                      skin === 'COPPEL'
                        ? `1px solid ${accentColor}`
                        : `2px solid ${accentColor}`
                    }
                    borderRadius={skin === 'COPPEL' ? '167px' : (skin === 'FINSUS' ? '4px' : '12px')}
                    p='0.3rem 0.6rem'
                    cursor='pointer'
                    onClick={() => handleCurrentRewardType(item, i)}
                    fontWeight={skin === 'COPPEL' ? '450' : '700'}
                  >
                    {item.label}
                  </Badge>
                </Box>
              )
            })}
          </SimpleGrid>
        </Box>
      </Box>
    )
  }

  const renderBusinessType = () => {
    return (
      <Box w='100%'>
        <Heading
          color='brand.secondaryDark'
          pt='2rem'
          fontSize={['xl', 'xl', 'xl', 'xl']}
        >
          {dictionary.TABS.modal_business_type}
        </Heading>
        <Box w='100%' pt='1rem'>
          <SimpleGrid columns={[1, 1, 1, 1]} spacingX='20px' spacingY='10px'>
            {businessType.map((item, i) => {
              return (
                <Box
                  key={i}
                  w='100%'
                  display='flex'
                  alignItems='flex-start'
                  justifyContent='center'
                  flexDirection='column'
                  p='0.5rem'
                >
                  <Badge
                    fontSize='0.8rem'
                    bg={
                      currentBusinessType?.includes(item.slug)
                        ? accentColor
                        : 'white'
                    }
                    variant='solid'
                    color={
                      currentBusinessType?.includes(item.slug)
                        ? 'white'
                        : accentColor
                    }
                    border={
                      skin === 'COPPEL'
                        ? `1px solid ${accentColor}`
                        : `2px solid ${accentColor}`
                    }
                    borderRadius={skin === 'COPPEL' ? '167px' : (skin === 'FINSUS' ? '4px' : '12px')}
                    p='0.3rem 0.6rem'
                    cursor='pointer'
                    onClick={() => handleCurrentBusinessType(item, i)}
                    fontWeight={skin === 'COPPEL' ? '450' : '700'}
                    id={item.slug}
                  >
                    {item.label}
                  </Badge>
                </Box>
              )
            })}
          </SimpleGrid>
        </Box>
      </Box>
    )
  }

  const renderCTA = () => {
    return (
      <Box
        pt='3rem'
        pb='1rem'
        display='flex'
        alignItems={skin === 'COPPEL' ? 'left' : 'center'}
        justifyContent={skin === 'COPPEL' ? 'left' : 'center'}
      >
        <Button
          shadow='xs'
          size='lg'
          bg={skin === 'FINSUS' ? '#FF5F54' : accentColor}
          borderRadius={skin === 'COPPEL' && '2px'}
          colorScheme='blue'
          color='white'
          padding={skin === 'COPPEL' && '0 16px'}
          _hover={{
            bg: skin === 'FINSUS' ? '#FF5F54' : accentColor,
            transform: 'scale(1.05)'
          }}
          _active={{
            bg: skin === 'FINSUS' ? '#FF5F54' : accentColor,
            transform: 'scale(0.95)'
          }}
          onClick={() => {
            handleFilters(
              currentCategory,
              currentReward[0],
              currentPrice[0],
              currentBusinessType[0]
            )
            filtersDataLayer(
              dictionary.TABS.cta,
              currentCategory,
              dictionary.TABS[`modal_price_${currentPrice[0]}`],
              currentReward[0],
              currentBusinessType[0],
              dictionary,
              skin
            )
            handleModal()
            setCurrentCategory([])
            setCurrentReward([])
            setCurrentPrice([])
            setCurrentBusinessType([])
          }}
        >
          <Heading
            m='px'
            fontSize={['sm', 'sm', 'md', 'md']}
            fontFamily={fontFamily}
            fontWeight='400'
          >
            {dictionary.TABS.cta}
          </Heading>
        </Button>
      </Box>
    )
  }

  return (
    <Modal
      isCentered
      isOpen={isOpen}
      onClose={() => {
        handleModal()
        setCurrentCategory([])
        setCurrentReward([])
        setCurrentPrice([])
        setCurrentBusinessType([])
      }}
      scrollBehavior='inside'
      size={skin === 'COPPEL' && 'full'}
    >
      <ModalOverlay
        bg='white.300'
        backdropFilter={
          skin === '' || skin === 'REWORTH'
            ? 'saturate(180%) blur(5px)'
            : skin === 'INVEX'
            ? 'saturate(80%) blur(2px)'
            : skin === 'UNIQ' ||
              skin === 'COPPEL' ||
              skin === 'LIVERPOOL' ||
              skin === 'SUBURBIA'
            ? 'saturate(60%) blur(2px)'
            : null
        }
      />
      <ModalContent
        bg={skin === 'COPPEL' ? 'brand.white' : 'brand.bg'}
        shadow='6px 6px 4px #00000029'
        p={
          skin === 'COPPEL'
            ? ['10px 10px', '10px 25px', '10px 30px', '20px 174px']
            : '0'
        }
      >
        <ModalHeader
          bgImage={
            skin !== 'COPPEL' &&
            'linear-gradient(288deg, #FFFFFF 100%, #FFFFFF 100%)'
          }
          borderTopRadius='8px'
          boxShadow='2px 3px 4px #585A5F33'
        >
          <Heading
            m='0px'
            color='brand.tabText'
            fontSize={['sm', 'sm', 'md', 'md']}
            fontFamily={fontFamily}
            fontWeight='500'
          >
            {dictionary.TABS.modal_title}
          </Heading>
        </ModalHeader>
        <ModalCloseButton
          color='#001B69'
          m={
            skin === 'COPPEL'
              ? ['10px 10px', '10px 25px', '10px 30px', '20px 174px']
              : '0'
          }
        />
        <ModalBody
          bgImage={
            skin !== 'COPPEL' &&
            'linear-gradient(288deg, #FFFFFF 100%, #FFFFFF 100%)'
          }
          p='1rem 1.4rem'
          borderBottomRadius='8px'
        >
          <Box w='100%'>
            {renderCategories()}
            {env !== 'legacy' ? renderPriceFilter() : null}
            {env !== 'legacy' ? renderRewardType() : null}
            {env !== 'legacy' ? renderBusinessType() : null}
            {renderCTA()}
          </Box>
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}

export default ModalFilters
